import { Link } from "react-router-dom";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { 
  Ship, 
  MapPin, 
  Clock, 
  CreditCard, 
  ShieldCheck, 
  Phone,
  ChevronRight,
  Coffee,
  ShoppingBag,
  Utensils,
  Anchor,
  BadgeCheck,
  ArrowLeftRight,
  Car,
  Play,
  Check,
  Snowflake,
  Briefcase,
  Users,
  Mail,
  Menu,
  X,
  Compass
} from "lucide-react";
import WhatsAppBubble from "../components/WhatsAppBubble";

const HERO_IMAGE = "https://images.unsplash.com/photo-1592963219683-3593d83276af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwY2FyZ28lMjBzaGlwJTIwcG9ydCUyMHRlcm1pbmFsfGVufDB8fHx8MTc2Nzk4MzQxNnww&ixlib=rb-4.1.0&q=85";
const TESLA_IMAGE = "https://customer-assets.emergentagent.com/job_seamen-shuttle/artifacts/sgg39vat_Tesla%20Y.JPG";
const MERCEDES_IMAGE = "https://customer-assets.emergentagent.com/job_seamen-shuttle/artifacts/8e1myubr_Mercedes%20V%20class.JPG";
const VW_CARAVELLE_IMAGE = "https://customer-assets.emergentagent.com/job_seamen-shuttle/artifacts/9vk95ug2_VW%20Caravelle.jpg";

const terminals = [
  { name: "TEST (1€)", price: 1 },
  { name: "Sogestrol", price: 40 },
  { name: "Jonction", price: 40 },
  { name: "TDF", price: 45 },
  { name: "CIM", price: 50 },
  { name: "TNMSC", price: 50 },
  { name: "Bougainville", price: 60 },
  { name: "Multivrac", price: 65 },
  { name: "Europe/Amériques", price: 45 }
];

const vehicleFeatures = [
  { icon: Snowflake, text: "Air-conditioned" },
  { icon: Check, text: "Clean & maintained" },
  { icon: Briefcase, text: "Luggage space" },
  { icon: Users, text: "Professional drivers" }
];

export default function HomePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-sm border-b border-slate-800">
        <div className="container-app">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-md bg-orange-500 flex items-center justify-center">
                <Anchor className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-black text-white tracking-tight">Y GO</span>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-6">
              <Link to="/excursions" className="text-slate-300 hover:text-white text-sm font-medium transition-colors">Visit Ideas</Link>
              <a href="#services" className="text-slate-300 hover:text-white text-sm font-medium transition-colors">Services</a>
              <a href="#pricing" className="text-slate-300 hover:text-white text-sm font-medium transition-colors">Pricing</a>
              <Link to="/terms" className="text-slate-300 hover:text-white text-sm font-medium transition-colors">Terms</Link>
              <Link to="/client/login" className="text-slate-300 hover:text-white text-sm font-medium transition-colors">My Account</Link>
            </div>
            
            {/* Desktop Book Now + Mobile Menu Button */}
            <div className="flex items-center gap-3">
              <Link to="/booking" className="hidden sm:block">
                <Button data-testid="nav-book-btn" className="bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-md">
                  Book Now
                </Button>
              </Link>
              
              {/* Mobile Menu Toggle */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="md:hidden p-2 text-slate-300 hover:text-white transition-colors"
                aria-label="Toggle menu"
              >
                {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
          
          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t border-slate-700">
              <div className="flex flex-col space-y-1">
                <Link 
                  to="/excursions" 
                  className="flex items-center gap-3 px-4 py-3 text-slate-300 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <Compass className="w-5 h-5 text-orange-400" />
                  <span className="font-medium">Visit Ideas</span>
                </Link>
                <a 
                  href="#services" 
                  className="flex items-center gap-3 px-4 py-3 text-slate-300 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <Car className="w-5 h-5 text-orange-400" />
                  <span className="font-medium">Services</span>
                </a>
                <a 
                  href="#pricing" 
                  className="flex items-center gap-3 px-4 py-3 text-slate-300 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <CreditCard className="w-5 h-5 text-orange-400" />
                  <span className="font-medium">Pricing</span>
                </a>
                <Link 
                  to="/terms" 
                  className="flex items-center gap-3 px-4 py-3 text-slate-300 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <ShieldCheck className="w-5 h-5 text-orange-400" />
                  <span className="font-medium">Terms</span>
                </Link>
                <Link 
                  to="/client/login" 
                  className="flex items-center gap-3 px-4 py-3 text-slate-300 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <Users className="w-5 h-5 text-orange-400" />
                  <span className="font-medium">My Account</span>
                </Link>
                <div className="pt-3 px-4">
                  <Link to="/booking" onClick={() => setMobileMenuOpen(false)}>
                    <Button className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold">
                      Book Now
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center pt-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/80 via-slate-900/70 to-slate-900/90" />
        
        <div className="relative z-10 container-app text-center py-20">
          <div className="max-w-4xl mx-auto animate-fade-in">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-md bg-orange-500 flex items-center justify-center">
                <Anchor className="w-10 h-10 md:w-12 md:h-12 text-white" />
              </div>
              <span className="text-4xl md:text-5xl font-black text-white tracking-tight">Y GO</span>
            </div>
            <p className="text-orange-400 font-bold text-sm tracking-widest uppercase mb-4">
              Seamen Shore Services
            </p>
            
            {/* SEO H1 */}
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white tracking-tight mb-6">
              Seamen Shuttle Service in Le Havre<br />
              <span className="text-orange-400">Port to City Center Transport</span>
            </h1>
            
            {/* SEO H2 as subtitle */}
            <h2 className="text-lg md:text-xl text-slate-300 mb-4 leading-relaxed max-w-3xl mx-auto font-normal">
              Safe, port-accredited shuttle service for seafarers between Le Havre port terminals and city center. 
              Direct ship pickup, fixed prices, 24/7 availability.
            </h2>
            
            {/* Port Accreditation Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-500/20 border border-green-500/40 rounded-full mb-8">
              <BadgeCheck className="w-5 h-5 text-green-400" />
              <span className="text-green-300 text-sm font-medium">Official Port-Accredited Drivers</span>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/booking">
                <Button 
                  data-testid="hero-book-btn"
                  size="lg"
                  className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-6 px-10 rounded-md shadow-lg uppercase tracking-wide text-base w-full sm:w-auto btn-press"
                >
                  Book Your Shuttle
                  <ChevronRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
              <a href="#pricing">
                <Button 
                  variant="outline"
                  size="lg"
                  className="border-2 border-white/30 text-white hover:bg-white/10 font-bold py-6 px-10 rounded-md uppercase tracking-wide text-base w-full sm:w-auto"
                >
                  View Fixed Prices
                </Button>
              </a>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-white/50 rounded-full" />
          </div>
        </div>
      </section>

      {/* Service Description Section */}
      <section className="py-16 bg-slate-50" id="services">
        <div className="container-app">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight">
                Port Terminals ⇄ Le Havre City Center Shuttle Service
              </h2>
            </div>
            
            {/* Visual Schematic */}
            <div className="bg-white rounded-xl p-8 shadow-sm border border-slate-100">
              <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12">
                {/* Port Terminal */}
                <div className="text-center">
                  <div className="w-24 h-24 bg-slate-900 rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg">
                    <Ship className="w-12 h-12 text-white" />
                  </div>
                  <p className="font-bold text-slate-900">Le Havre Port</p>
                  <p className="text-sm text-slate-500">All terminals served</p>
                </div>

                {/* Double Arrow with Shuttle */}
                <div className="flex flex-col items-center py-4">
                  <div className="flex items-center gap-2">
                    <ArrowLeftRight className="w-8 h-8 text-orange-500" />
                  </div>
                  <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center my-3 shadow-lg animate-pulse">
                    <Car className="w-8 h-8 text-white" />
                  </div>
                  <p className="text-xs text-slate-500 text-center max-w-[120px]">Two-way service</p>
                </div>

                {/* City Center */}
                <div className="text-center">
                  <div className="w-24 h-24 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg">
                    <MapPin className="w-12 h-12 text-white" />
                  </div>
                  <p className="font-bold text-slate-900">City Center</p>
                  <p className="text-sm text-slate-500">Shopping, restaurants, bars</p>
                </div>
              </div>

              <div className="mt-8 text-center">
                <p className="text-slate-600 text-lg">
                  Complete shuttle service for crew members between all Le Havre port terminals and city center. 
                  Ship-to-city and city-to-ship transport available for your shore leave.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust & Differentiation Section */}
      <section className="section-padding bg-white">
        <div className="container-app">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight">
              Why Choose Y GO Seamen Shore Services in Le Havre?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-slate-50 p-8 rounded-md border border-slate-100 shadow-sm hover:border-orange-500/50 transition-all duration-200 card-hover">
              <div className="feature-icon mb-5">
                <CreditCard className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Fixed & Transparent Pricing</h3>
              <p className="text-slate-600">Know your fare before you book. Price per vehicle, no hidden fees, no surprises.</p>
            </div>
            
            <div className="bg-slate-50 p-8 rounded-md border border-slate-100 shadow-sm hover:border-orange-500/50 transition-all duration-200 card-hover">
              <div className="feature-icon mb-5">
                <BadgeCheck className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Official Port-Accredited Drivers</h3>
              <p className="text-slate-600">All drivers hold valid port access badges and are authorized to enter all Le Havre terminals.</p>
            </div>
            
            <div className="bg-slate-50 p-8 rounded-md border border-slate-100 shadow-sm hover:border-orange-500/50 transition-all duration-200 card-hover">
              <div className="feature-icon mb-5">
                <Clock className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">24/7 Availability</h3>
              <p className="text-slate-600">Service available day and night. Night surcharge +20% applies between 21:00 and 06:00.</p>
            </div>
            
            <div className="bg-slate-50 p-8 rounded-md border border-slate-100 shadow-sm hover:border-orange-500/50 transition-all duration-200 card-hover">
              <div className="feature-icon mb-5">
                <MapPin className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">All Le Havre Port Terminals Served</h3>
              <p className="text-slate-600">We cover all major terminals including Sogestrol, Jonction, TDF, CIM, TNMSC, Bougainville, and more.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Port Accreditation Section */}
      <section className="section-padding bg-slate-50">
        <div className="container-app">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-6">
                Officially Port-Accredited Shuttle Drivers
              </h2>
              <div className="space-y-4 text-slate-600">
                <p>
                  All Y GO drivers are fully accredited and authorized to access Le Havre port facilities. 
                  This means we can pick you up <strong className="text-slate-900">directly at your ship</strong>, 
                  not outside the port gates.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <ShieldCheck className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                    <span><strong>ISPS Compliance</strong> - All security requirements met</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <BadgeCheck className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                    <span><strong>Authorized Terminal Access</strong> - Valid port credentials</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Ship className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                    <span><strong>Direct Ship Pickup</strong> - We come to you</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Clock className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                    <span><strong>No Waiting Outside Port</strong> - Save time on your shore leave</span>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="relative">
              {/* Video Placeholder */}
              <div 
                className="rounded-md shadow-xl w-full h-[400px] bg-slate-900 relative overflow-hidden group cursor-pointer"
                data-testid="driver-video-placeholder"
              >
                <img 
                  src={MERCEDES_IMAGE} 
                  alt="Port-accredited professional driver service in Le Havre"
                  className="w-full h-full object-cover opacity-60"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-20 h-20 bg-orange-500 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <Play className="w-10 h-10 text-white ml-1" />
                  </div>
                </div>
                <div className="absolute bottom-4 left-4 right-4 text-center">
                  <p className="text-white text-sm font-medium bg-black/50 px-3 py-1 rounded inline-block">
                    Watch our service in action
                  </p>
                </div>
              </div>
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-md shadow-lg max-w-xs">
                <div className="flex items-center gap-3 mb-2">
                  <BadgeCheck className="w-8 h-8 text-green-500" />
                  <span className="text-2xl font-black text-slate-900">100%</span>
                </div>
                <p className="text-sm text-slate-600">Port-accredited professional drivers with valid access badges</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shore Leave Experience Section */}
      <section className="section-padding bg-white">
        <div className="container-app">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-4">
              Make the Most of Your Shore Leave in Le Havre
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Le Havre offers excellent opportunities for seafarers during shore leave. 
              Our drivers know the best spots and can recommend local favorites.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6 bg-slate-50 rounded-xl">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <Coffee className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Cafés</h3>
              <p className="text-slate-600">Enjoy authentic French coffee and pastries at local cafés in the city center.</p>
            </div>
            
            <div className="text-center p-6 bg-slate-50 rounded-xl">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <Utensils className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Restaurants</h3>
              <p className="text-slate-600">From seafood to international cuisine, Le Havre has dining options for every taste.</p>
            </div>
            
            <div className="text-center p-6 bg-slate-50 rounded-xl">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <ShoppingBag className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Shopping</h3>
              <p className="text-slate-600">Visit local shops and the commercial center for souvenirs and essentials.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Fleet Section */}
      <section className="section-padding bg-slate-50">
        <div className="container-app">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-4">
              Modern & Comfortable Vehicles for Seafarers
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Our fleet is maintained to the highest standards for your comfort and safety.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-10">
            <div className="bg-white rounded-xl overflow-hidden border border-slate-100 shadow-sm">
              <img 
                src={TESLA_IMAGE} 
                alt="Tesla Model Y shuttle vehicle for eco-conscious seafarers"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="font-bold text-slate-900 mb-2">Tesla Model Y</h3>
                <p className="text-sm text-slate-600">Electric luxury for eco-conscious travelers. Quiet, comfortable, and modern.</p>
              </div>
            </div>
            <div className="bg-white rounded-xl overflow-hidden border border-slate-100 shadow-sm">
              <img 
                src={MERCEDES_IMAGE} 
                alt="Mercedes V-Class shuttle for groups up to 7 passengers"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="font-bold text-slate-900 mb-2">Mercedes V-Class</h3>
                <p className="text-sm text-slate-600">Spacious comfort for groups up to 7. Premium interior, smooth ride.</p>
              </div>
            </div>
            <div className="bg-white rounded-xl overflow-hidden border border-slate-100 shadow-sm">
              <img 
                src={VW_CARAVELLE_IMAGE} 
                alt="Volkswagen Caravelle for large crew transport"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="font-bold text-slate-900 mb-2">Volkswagen Caravelle</h3>
                <p className="text-sm text-slate-600">Reliable transport for larger crews. Plenty of space for luggage.</p>
              </div>
            </div>
          </div>

          {/* Vehicle Features */}
          <div className="bg-white rounded-xl p-6 border border-slate-100">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {vehicleFeatures.map((feature, index) => (
                <div key={index} className="flex items-center gap-3 p-3">
                  <feature.icon className="w-5 h-5 text-orange-500" />
                  <span className="text-slate-700 font-medium">{feature.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="section-padding bg-white">
        <div className="container-app">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-4">
              Fixed Shuttle Prices – Le Havre Port
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Transparent pricing per vehicle. Price includes all passengers. Night surcharge +20% applies between 21:00 and 06:00.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 max-w-5xl mx-auto mb-8">
            {terminals.map((terminal, index) => (
              <div 
                key={index} 
                className={`bg-slate-50 rounded-lg p-4 text-center border border-slate-100 hover:border-orange-500/50 transition-colors ${terminal.price === 1 ? 'border-orange-500 bg-orange-50' : ''}`}
              >
                <p className="font-medium text-slate-700 text-sm mb-2">{terminal.name}</p>
                <p className="text-2xl font-black text-slate-900">€{terminal.price}</p>
                <p className="text-xs text-slate-500 mt-1">per vehicle</p>
              </div>
            ))}
          </div>

          <div className="bg-slate-900 rounded-xl p-6 text-center max-w-2xl mx-auto">
            <div className="flex items-center justify-center gap-2 mb-2">
              <Clock className="w-5 h-5 text-orange-400" />
              <span className="text-orange-400 font-bold">Night Service</span>
            </div>
            <p className="text-slate-300">
              +20% surcharge for pickups between <strong className="text-white">21:00 and 06:00</strong>
            </p>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="section-padding bg-gradient-to-r from-slate-900 to-slate-800">
        <div className="container-app text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-6">
            Book Your Seamen Shuttle in Le Havre
          </h2>
          <div className="flex flex-wrap justify-center gap-6 mb-8 text-slate-300">
            <div className="flex items-center gap-2">
              <BadgeCheck className="w-5 h-5 text-green-400" />
              <span>Port-accredited drivers</span>
            </div>
            <div className="flex items-center gap-2">
              <Ship className="w-5 h-5 text-orange-400" />
              <span>Direct ship pickup</span>
            </div>
            <div className="flex items-center gap-2">
              <CreditCard className="w-5 h-5 text-orange-400" />
              <span>Fixed pricing</span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="w-5 h-5 text-orange-400" />
              <span>24/7 availability</span>
            </div>
          </div>
          <Link to="/booking">
            <Button 
              data-testid="cta-book-btn"
              size="lg"
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-6 px-12 rounded-md shadow-lg uppercase tracking-wide text-lg btn-press"
            >
              Book Shuttle Now
              <ChevronRight className="ml-2 w-6 h-6" />
            </Button>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800">
        <div className="container-app">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-md bg-orange-500 flex items-center justify-center">
                  <Anchor className="w-6 h-6 text-white" />
                </div>
                <span className="text-xl font-black text-white">Y GO</span>
              </div>
              <p className="text-sm">
                Y GO – Seamen Shore Services<br />
                Professional shuttle transport for seafarers in Le Havre Port.
              </p>
            </div>
            <div>
              <h3 className="text-white font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/booking" className="hover:text-orange-400 transition-colors">Book Shuttle</Link></li>
                <li><Link to="/excursions" className="hover:text-orange-400 transition-colors">Visit Ideas</Link></li>
                <li><a href="#pricing" className="hover:text-orange-400 transition-colors">Pricing</a></li>
                <li><Link to="/terms" className="hover:text-orange-400 transition-colors">Terms & Conditions</Link></li>
                <li><Link to="/admin" className="hover:text-orange-400 transition-colors">Admin</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-white font-bold mb-4">Contact</h3>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center gap-2">
                  <Phone className="w-4 h-4 shrink-0" />
                  <a href="tel:+33278780404" className="hover:text-orange-400 transition-colors">+33 2 78 78 04 04</a>
                </li>
                <li className="flex items-center gap-2">
                  <Mail className="w-4 h-4 shrink-0" />
                  <a href="mailto:booking@y-go.fr" className="hover:text-orange-400 transition-colors break-all">booking@y-go.fr</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-800 mt-8 pt-8 text-center text-sm">
            <p>© {new Date().getFullYear()} Y GO – Seamen Shore Services. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Bubble */}
      <WhatsAppBubble />
    </div>
  );
}
